import { ApolloError } from '@apollo/client'
import { Maybe } from 'gql'
import { t } from 'shared'

export const formHasNewFile = (formNode: HTMLElement) => {
  return [...formNode.querySelectorAll<HTMLInputElement>('input[type=file]')].filter((i) => i.files?.length).length > 0
}

export const messageForErrorSymbol = (errorSymbol: string) => {
  return t(`error.${errorSymbol}`, { defaultValue: errorSymbol })
}

export const firstErrorFrom = (update?: Maybe<{ messages?: Maybe<Array<{ message: string }>> }>) => {
  return first(update?.messages)
}

export const errorsFrom = (update?: Maybe<{ messages?: Maybe<Array<{ message: string; field: string }>> }>) => {
  // this picks up only the last error for a field if there are multiple
  const errors: Record<string, string> = {}
  for (const msg of update?.messages || []) errors[msg.field] = msg.message
  return errors
}

export const first = <T extends { message: string }>(arr: Array<T> | ReadonlyArray<T> | undefined | null) => {
  return arr && arr[0] && arr[0].message
}
export const firstFromApolloError = (error: ApolloError | undefined) => {
  return error && (first(error.clientErrors) || error.networkError?.message || first(error.graphQLErrors))
}
